<template>
  <div style="position: relative">
    <div class="iconfont icon-fangda" @click="show_chart_dialog = !show_chart_dialog"></div>
    <div
      style="width: 100%; height: 420px; margin-top: 10px"
      ref="chart"
      id="c_5424"
      v-loading="loading"
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)"></div>
    <div style="margin-top: 30px">
      <el-table
        v-loading="loading"
        element-loading-text="数据量巨大，正在计算中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 1)"
        class="table1"
        :header-cell-style="tableStyle"
        :data="tabData"
        style="width: 100%"
        :row-class-name="tableRowClassName">
        <el-table-column prop="index" label="代码" min-width="94"> </el-table-column>
        <el-table-column
          :formatter="formatterColumn"
          :prop="k"
          :label="k"
          min-width="94"
          sortable
          align="right"
          v-for="k in tabKeys"
          :key="k">
        </el-table-column>
      </el-table>
    </div>
    <ChartDialog :show.sync="show_chart_dialog" :echart_options="chart_options" />
  </div>
</template>

<script>
import { debounce, number2Pct, numberFix2 } from '@/utils';
import { fnReturnTableStyle } from '@/utils/util';

import ChartDialog from '../../Basic/ChartDialog.vue';

export default {
  props: {
    chart_data: Array,
    loading: Boolean,
  },
  components: {
    ChartDialog,
  },
  data() {
    return {
      ROOTFONTFIZE: '',
      chart_options: {},
      show_chart_dialog: false,
    };
  },
  watch: {
    currentTheme() {
      this.fnGetTheme();
      this.debounceRender();
    },
    chart_data() {
      this.debounceRender();
    },
  },
  computed: {
    tabKeys() {
      if (this.chart_data.length === 0) return [];
      return Object.keys(this.chart_data[0]).filter((n) => n !== 'index');
    },
    tabData() {
      const sort_map = {
        机构持有比例: { sort: 1, text: '机构占比' },
        '机构 - 前10大流通持有比例': { sort: 2, text: '机构持有前10大流通' },
        '机构 - 前10大非流通持有比例': { sort: 3, text: '机构持有前10大非流通' },
        '机构 - 机构-非排名前10大持有比例': {
          sort: 4,
          text: '机构-非排名前10大',
        },
        个人持有比例: { sort: 5, text: '个人' },
        总持有人数: { sort: 6, text: '总持有人数' },
        发布财报REITs个数: { sort: 7, text: '发布财报REITs个数' },
        单个REITs持有人数: { sort: 8, text: '单个REITs持有人数' },
      };
      return this.chart_data
        .slice(0)
        .sort((a, b) => {
          return sort_map[a.index].sort - sort_map[b.index].sort;
        })
        .map((item) => {
          return {
            ...item,
            index: sort_map[item.index].text,
          };
        });
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
  },
  methods: {
    tableRowClassName({ row }) {
      const name = row.index;
      const isDark = this.currentTheme !== 'light';
      if (['机构占比', '个人', '单个REITs持有人数'].includes(name)) {
        return isDark ? 'dark-row' : 'light-row';
      }
    },
    formatterColumn(row, column, cellValue, index) {
      const name = row.index;
      if (['总持有人数', '发布财报REITs个数', '单个REITs持有人数'].includes(name)) {
        return numberFix2(cellValue, 0);
      } else {
        return number2Pct(cellValue);
      }
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
    },
    resize() {
      this.fnGetWidth();
      this.echart_instance && this.echart_instance.resize();
    },
    fnGetTheme() {
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },
    debounceRender: debounce(function () {
      this.chartRender();
    }, 400),
    chartRender() {
      if (!this.chart_data.length) {
        this.echart_instance && this.echart_instance.clear();
        return;
      }
      if (!this.echart_instance) {
        this.echart_instance = this.$echarts.init(this.$refs.chart);
      }
      this.echart_instance.clear();

      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      const item_map = {
        '机构 - 机构-非排名前10大持有比例': {
          sort: 1,
          text: '机构-非排名前10大',
        },
        '机构 - 前10大非流通持有比例': { sort: 2, text: '机构持有前10大非流通' },
        '机构 - 前10大流通持有比例': { sort: 3, text: '机构持有前10大流通' },
        个人持有比例: { sort: 4, text: '个人' },
        总持有人数: { sort: 5, text: '总持有人数(右轴)' },
        单个REITs持有人数: { sort: 6, text: '单个REITs持有人数(右轴)' },
        机构持有比例: { sort: 7, text: '' },
        发布财报REITs个数: { sort: 8, text: '' },
      };
      const color_map = {
        '机构-非排名前10大': '#5ae8ed',
        机构持有前10大非流通: '#4e95d9',
        机构持有前10大流通: '#5e5ce6',
        个人: '#4ea72e',
        '总持有人数(右轴)': '#e97132',
        '单个REITs持有人数(右轴)': '#ff3300',
      };
      const data = this.chart_data
        .filter((item) => item.index !== '机构持有比例' && item.index !== '发布财报REITs个数')
        .sort((a, b) => item_map[a.index].sort - item_map[b.index].sort)
        .map((item) => {
          return {
            ...item,
            index: item_map[item.index].text,
          };
        });
      const xLabel = Object.keys(data[0]).filter((k) => k !== 'index');
      const type_line = ['总持有人数(右轴)', '单个REITs持有人数(右轴)'];

      const series = data.map((item) => {
        const { index, ...args } = item;
        return {
          name: item.index,
          data: Object.values(args),
          type: type_line.includes(item.index) ? 'line' : 'bar',
          stack: type_line.includes(item.index) ? item.index : 'stack',
          yAxisIndex: type_line.includes(item.index) ? 1 : 0,
          symbolSize: 0,
          itemStyle: {
            color: color_map[item.index],
          },
          // barWidth: 70,
        };
      });

      const options = {
        series,
        xAxis: {
          type: 'category',
          data: xLabel,
          axisLabel: {
            interval: 0,
            margin: OPTIONDATA.xAxis.axisLabel.margin,
            fontSize: OPTIONDATA.xAxis.axisLabel.fontSize,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
          },
        },
        yAxis: [
          {
            axisLabel: {
              show: true,
              interval: 'auto',
              formatter: (value) => {
                return value * 100 + '%';
              },
              fontSize: OPTIONDATA.yAxis.axisLabel.fontSize,
              color: OPTIONDATA.yAxis.axisLabel.color,
            },
            splitLine: OPTIONDATA.yAxis.splitLine,
          },
          {
            axisLabel: {
              show: true,
              interval: 'auto',
              fontSize: OPTIONDATA.yAxis.axisLabel.fontSize,
              color: OPTIONDATA.yAxis.axisLabel.color,
            },
            splitLine: OPTIONDATA.yAxis.splitLine,
          },
        ],
        legend: {
          type: 'plain',
          bottom: '0%',
          left: 'center',
          itemGap: 10,
          textStyle: {
            color: OPTIONDATA.legend.textStyle.color,
            fontSize: this.ROOTFONTFIZE * (12 / 144),
          },
          data: data.map((item) => {
            const { index } = item;
            return {
              name: index,
              icon: type_line.includes(item.index) ? 'path://M0,0 L10,0 L10,1 L0,1 Z' : 'rect',
            };
          }),
        },
        toolbox: {
          // 工具箱按钮
          right: 30,
          top: -5,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            const p = params[0].name;
            return (
              p +
              ' <br />' +
              params
                .map(({ marker, seriesName, value }) => {
                  const k = seriesName;
                  const v = seriesName.indexOf('右轴') > 0 ? value : number2Pct(value);

                  return marker + k + `<span style="margin-left:10px">${v}</span>`;
                })
                .join('<br />')
            );
          },
        },
        grid: {
          top: this.ROOTFONTFIZE * (50 / 144),
          left: this.ROOTFONTFIZE * (35 / 144),
          right: this.ROOTFONTFIZE * (60 / 144),
          bottom: this.ROOTFONTFIZE * (40 / 144),
          containLabel: true,
        },
      };
      this.echart_instance.setOption(options);
      this.echart_instance.resize();
      this.chart_options = Object.freeze(options);
    },
  },
  mounted() {
    /*    const colors = this.$store.state.colors || [];
    this.colors = colors.reduce((p, c) => {
      p[c.name] = c.value;
      return p;
    }, {}); */
    this.debounceRender();
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    this.echart_instance && this.echart_instance.dispose();
  },
};
</script>

<style lang="less" scoped>
.icon-fangda {
  position: absolute;
  right: 8px;
  top: 4px;
}

/deep/.el-table .light-row > * {
  background-color: rgb(247, 247, 247) !important;
}
/deep/.el-table .dark-row > * {
  background-color: #4c4f5e !important;
}

//fix 滚动条重叠部分背景颜色
/deep/.el-table__body-wrapper::-webkit-scrollbar-corner {
  background-color: transparent;
}
/deep/.items-center {
  align-items: center;
}
/deep/.relative {
  position: relative;
}
/deep/.flex {
  display: flex;
}

/* el-table start */

::v-deep .table1 table {
  border: none;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* el-table end */
</style>
